/* eslint-disable no-unused-vars */
const nonagons = [
  {
    x: 75,
    y: 17,
  },  {
    x: 105,
    y: 3,
  },
  {
    x: 145,
    y: 6,
  }, {
    x: 181,
    y: 35,
  },
  {
    x: 189,
    y: 85,
  },  {
    x: 168,
    y: 122,
  },
  {
    x: 127,
    y: 140,
  },  {
    x: 87,
    y: 132,
  },
  {
    x: 58,
    y: 101,
  },  {
    x: 52,
    y: 62,
  },
  {
    x: 75,
    y: 17,
  },
];
const foundedHighlighted = [
  {
    x: 75,
    y: 17,
  },  {
    x: 105,
    y: 3,
  },
  {
    x: 145,
    y: 6,
  }, {
    x: 181,
    y: 35,
  },
  {
    x: 189,
    y: 85,
  },  {
    x: 168,
    y: 122,
  },
];
const membersHighlighted = [
  {
    x: 52,
    y: 62,
  }, {
    x: 75,
    y: 17,
  },
  {
    x: 105,
    y: 3,
  }, {
    x: 145,
    y: 6,
  }, {
    x: 181,
    y: 35,
  },
  {
    x: 189,
    y: 85,
  },  {
    x: 168,
    y: 122,
  },
  {
    x: 127,
    y: 140,
  },  {
    x: 87,
    y: 132,
  },
  {
    x: 58,
    y: 101,
  },
];
const subteamsHighlighted = [
  {
    x: 52,
    y: 62,
  }, {
    x: 75,
    y: 17,
  },
  {
    x: 105,
    y: 3,
  }, {
    x: 145,
    y: 6,
  }, {
    x: 181,
    y: 35,
  },
];
const yearsHighlighted = [
  {
    x: 181,
    y: 35,
  },
  {
    x: 189,
    y: 85,
  },  {
    x: 168,
    y: 122,
  },
  {
    x: 127,
    y: 140,
  },  {
    x: 87,
    y: 132,
  },
  {
    x: 58,
    y: 101,
  }, {
    x: 52,
    y: 62,
  },
];
const firstsHighlighted = [
  {
    x: 189,
    y: 85,
  },  {
    x: 168,
    y: 122,
  },
  {
    x: 127,
    y: 140,
  },  {
    x: 87,
    y: 132,
  },
];
//This is the accessor function we talked about above
const lineFunction = d3.line()
  .x(function(d) { return d.x; })
  .y(function(d) { return d.y; })
  .curve(d3.curveLinear);

//The SVG Container
const svgContainer = d3.select('#statistics').append('svg')
  .attr('width', 1000)
  .attr('height', 300);

//The line SVG Path we draw
const founded = svgContainer.append('path')
  .attr('d', lineFunction(nonagons))
  .attr('stroke', '#707070')
  .attr('stroke-opacity', '0.4')
  .attr('stroke-width', 2)
  .attr('fill', 'none')
  .attr('transform', 'translate(0,100)');

const foundedHighlightedLine = svgContainer.append('path')
  .attr('d', lineFunction(foundedHighlighted))
  .attr('stroke', '#E22828')
  .attr('stroke-width', 3)
  .attr('fill', 'none')
  .attr('id', 'foundedLine')
  .attr('transform', 'translate(0,100)');

const members = svgContainer.append('path')
  .attr('d', lineFunction(nonagons))
  .attr('stroke', '#707070')
  .attr('stroke-opacity', '0.4')
  .attr('stroke-width', 2)
  .attr('fill', 'none')
  .attr('transform', 'rotate(-10) translate(150,100)');

const membersHighlightedLine = svgContainer.append('path')
  .attr('d', lineFunction(membersHighlighted))
  .attr('stroke', '#0027FF')
  .attr('stroke-width', 3)
  .attr('fill', 'none')
  .attr('id', 'membersLine')
  .attr('transform', 'rotate(-10) translate(150,100)');

const subteams = svgContainer.append('path')
  .attr('d', lineFunction(nonagons))
  .attr('stroke', '#707070')
  .attr('stroke-opacity', '0.4')
  .attr('stroke-width', 2)
  .attr('fill', 'none')
  .attr('transform', 'rotate(5) translate(380,50)');

const subteamsHighlightedLine = svgContainer.append('path')
  .attr('d', lineFunction(subteamsHighlighted))
  .attr('stroke', '#B70000')
  .attr('stroke-width', 3)
  .attr('fill', 'none')
  .attr('id', 'subteamsLine')
  .attr('transform', 'rotate(5) translate(380,50)');

const years = svgContainer.append('path')
  .attr('d', lineFunction(nonagons))
  .attr('stroke', '#707070')
  .attr('stroke-opacity', '0.4')
  .attr('stroke-width', 2)
  .attr('fill', 'none')
  .attr('class', 'years-nonagon')
  .attr('transform', 'rotate(-5) translate(550,100)');

const yearsHighlightedLine = svgContainer.append('path')
  .attr('d', lineFunction(yearsHighlighted))
  .attr('stroke', '#242424')
  .attr('stroke-width', 3)
  .attr('fill', 'none')
  .attr('class', 'years-nonagon')
  .attr('id', 'yearsLine')
  .attr('transform', 'rotate(-5) translate(550,100)');

const firsts = svgContainer.append('path')
  .attr('d', lineFunction(nonagons))
  .attr('stroke', '#707070')
  .attr('stroke-opacity', '0.4')
  .attr('stroke-width', 2)
  .attr('fill', 'none')
  .attr('class', 'firsts-nonagon')
  .attr('transform', 'rotate(0) translate(730,100)');

const firstsHighlightedLine = svgContainer.append('path')
  .attr('d', lineFunction(firstsHighlighted))
  .attr('stroke', '#0048D0')
  .attr('stroke-width', 3)
  .attr('fill', 'none')
  .attr('class', 'firsts-nonagon')
  .attr('id', 'firstsLine')
  .attr('transform', 'rotate(0) translate(730,100)');

svgContainer.append('text')
  .attr('x', 85)
  .attr('y', 180)
  .attr('class', 'stats-bold')
  .text('\'02');

svgContainer.append('text')
  .attr('x', 95)
  .attr('y', 200)
  .attr('class', 'stats-regular')
  .text('founded');

svgContainer.append('text')
  .attr('x', 270)
  .attr('y', 130)
  .attr('class', 'stats-bold')
  .text('77');

svgContainer.append('text')
  .attr('x', 250)
  .attr('y', 150)
  .attr('class', 'stats-regular')
  .text('team members');

svgContainer.append('text')
  .attr('x', 475)
  .attr('y', 180)
  .attr('class', 'stats-bold')
  .text('7');

svgContainer.append('text')
  .attr('x', 460)
  .attr('y', 200)
  .attr('class', 'stats-regular')
  .text('subteams');

svgContainer.append('text')
  .attr('x', 660)
  .attr('y', 120)
  .attr('class', 'stats-bold years-text')
  .text('24');

svgContainer.append('text')
  .attr('x', 643)
  .attr('y', 140)
  .attr('class', 'stats-regular years-text')
  .text('years of flight');

svgContainer.append('text')
  .attr('x', 835)
  .attr('y', 180)
  .attr('class', 'stats-bold firsts-text')
  .text('4');

svgContainer.append('text')
  .attr('x', 803)
  .attr('y', 200)
  .attr('class', 'stats-regular firsts-text')
  .text('firsts in mission');
